export default __webpack_public_path__ + "static/media/Contact-us-Banner-2560x600.3ccb9d82.jpg";